import type { Slide } from './types'
export { API_BASE } from '../shared/api/client'

export const DEFAULT_HOMEPAGE_SLUG = '/'

export const FALLBACK_SLIDES: Slide[] = [
  {
    id: 's1',
    title: 'Aurora Sneakers',
    description: 'Mesh riciclato, suola ultraleggera e spedizione in 24h.',
    ctaLabel: 'Scopri la collezione',
    ctaHref: '#sneakers',
    image:
      'https://images.unsplash.com/photo-1528701800489-20be9a43a028?auto=format&fit=crop&w=1400&q=80',
  },
  {
    id: 's2',
    title: 'Backpack Nimbus',
    description: 'Tessuto idrorepellente, tasca laptop 16" e porta USB.',
    ctaLabel: 'Vai allo shop',
    ctaHref: '#zaini',
    image:
      'https://images.unsplash.com/photo-1504280645497-00afe6a10a2d?auto=format&fit=crop&w=1400&q=80',
  },
  {
    id: 's3',
    title: 'Pulse Smartwatch',
    description: 'Monitoraggio salute, GPS e pagamenti contactless.',
    ctaLabel: 'Vedi dettagli',
    ctaHref: '#wearable',
    image:
      'https://images.unsplash.com/photo-1546868871-7041f2a55e12?auto=format&fit=crop&w=1400&q=80',
  },
]
